import { render } from "./EditP2PROCModal.vue?vue&type=template&id=df6a83ee&scoped=true"
import script from "./EditP2PROCModal.vue?vue&type=script&lang=js"
export * from "./EditP2PROCModal.vue?vue&type=script&lang=js"

import "./EditP2PROCModal.vue?vue&type=style&index=0&id=df6a83ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6a83ee"]])

export default __exports__